import { jsx as o } from "react/jsx-runtime";
import { createContext as r, useContext as i } from "react";
const e = r({});
function u({
  config: t,
  children: n
}) {
  return /* @__PURE__ */ o(e.Provider, { value: t, children: n });
}
function f() {
  return i(e);
}
export {
  u as DesignSystemProvider,
  f as useDesignSystemConfig
};
//# sourceMappingURL=DesignSystemProvider.js.map
